<template>
  <Modal
    centered
    :visible="visible"
    :title="null"
    :animated="false"
    :footer="null"
    :body-style="{ width: '360px', height: '480px', padding: 0 }"
    wrap-class-name="invite-friend-modal-wrapper"
    :width="360"
    :afterClose="handleReset"
    @change="$emit('change', $event)"
    destroy-on-close
  >
    <template v-if="opsStep === opsStepType.CHECK_ACCOUNT">
      <div style="padding: 0 40px">
        <div class="title">{{$t('home.AddFriend')}}</div>
        <FormModel class="search-form" ref="formRef" :model="formModel" :rules="formRules">
          <FormModelItem prop="key">
            <IndentInput :placeholder="$t('home.AddPhoneAndUsername')" allow-clear autoFocus v-model="formModel.key" />
          </FormModelItem>
        </FormModel>
      </div>

      <div class="footer-content">
        <BaiscBtnGroup
          @primeClick="handleInviteSearch"
          @defClick="$emit('change', false)"
          class="basic-btns"
        />
      </div>
    </template>
    <template v-else-if="opsStep === opsStepType.SHOW_INVITE">
      <div class="back-pos" @click="handleReset">
        <SvgIcon class-name="back-icon" icon-class="arrow-left" />
      </div>
      <div class="user-panel-rect">
        <UserPanel class="single-line" :user="user" />
      </div>
      <div class="footer-content">
        <Button
          v-if="user.grantedHileia"
          class="invite-block-btn"
          shape="round"
          @click="handleInviteCoc"
          >{{$t('home.RequestAdd')}}</Button
        >
        <div v-else class="text-center text-grey">{{$t('home.PeopleNotHiLeiaAuth')}}</div>
      </div>
    </template>
  </Modal>
</template>
<script>
import { Modal, FormModel, Button, message } from 'ant-design-vue'
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import BaiscBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import UserPanel from '@/components/business/user-panel/index.vue'
import { mapActions, mapState } from 'vuex'
import IndentInput from '@/components/behavior/indent-input/index.vue'

const OPS_STEP_TYPE = Object.freeze({
  CHECK_ACCOUNT: 'CHECK_ACCOUNT',
  SHOW_INVITE: 'SHOW_INVITE'
})

// 邀请好友
export default {
  name: 'InviteFriendModal',
  components: {
    Modal,
    FormModelItem: FormModel.Item,
    FormModel,
    BaiscBtnGroup,
    SvgIcon,
    UserPanel,
    Button,
    IndentInput
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const _this = this
    return {
      opsStep: OPS_STEP_TYPE.CHECK_ACCOUNT,
      formModel: this.resetForm(),
      formRules: {
        key: [
          { required: true, get message(){ return _this.$t('common.PleaseFillAccount') }, trigger: 'change' },
          {
            validator: (rule, value, cb) => {
              return this.inviteSearch({ key: value })
            },
            trigger: 'submit'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('inviteFriend', ['inviteSearch', 'inviteCoc']),
    handleInviteSearch() {
      this.$refs.formRef
        .validate({ first: true })
        .then(res => {
          this.opsStep = OPS_STEP_TYPE.SHOW_INVITE
        })
        .catch(() => {})
    },
    async handleInviteCoc() {
      const { cocKey } = this.user
      const uid = this.userInfo.id
      try {
        await this.inviteCoc({ cocKey, uids: [uid] })
        message.success(this.$t('home.AddFriendSucc'))
        this.$emit('ok')
        this.$emit('change', false)
      } catch (err) {
        message.error(err.message)
      }
    },
    handleReset() {
      this.opsStep = OPS_STEP_TYPE.CHECK_ACCOUNT
      this.formModel = this.resetForm()
    },
    resetForm() {
      return {
        key: ''
      }
    }
  },
  computed: {
    ...mapState('inviteFriend', ['user']),
    ...mapState(['userInfo']),
    opsStepType() {
      return OPS_STEP_TYPE
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
::v-deep .invite-friend-modal-wrapper {
  & > .ant-modal {
    padding-bottom: 0;
    & > .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border: 1px solid #edeff2;
      overflow: hidden;

      & .ant-modal-body {
        &::before {
          content: " ";
          display: table;
        }
      }
    }
  }

  .title {
    .medium-font(18);
    text-align: center;
    margin-bottom: 32px;
    margin-top: 56px;
  }

  .invite-block-btn {
    color: #fff;
    height: 41px;
    background: linear-gradient(
      154deg,
      #236cff 0%,
      rgba(35, 108, 255, 0.8) 100%
    );
    box-shadow: 0px 5px 10px 0px rgba(35, 108, 255, 0.5);
    border-radius: 20px;
    border: 1px solid transparent;
    display: block;
    width: 216px;
    margin: 0 auto;
  }

  .back-pos {
    position: absolute;
    left: 21px;
    top: 16px;
    width: 56px;
    height: 56px;
    cursor: pointer;
  }

  .back-icon {
    font-size: 24px;
    color: #000;
  }

  .user-panel-rect {
    width: 200px;
    margin: 80px auto 0;
  }

  .footer-content {
    position: absolute;
    bottom: 40px;
    width: 100%;
  }

  .basic-btns {
    width: 272px;
    margin: 0 auto;
    & > .default-btn {
      color: #000;
    }
  }
}

.single-line {
  //人员面板单行显示
  ::v-deep .ant-list-item-meta-content {
    min-width: 0;
  }
  ::v-deep .info-content,
  ::v-deep .info-title,
  ::v-deep .info-subtitle {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.search-form {
  ::v-deep .ant-form-explain {
    margin-top: 12px;
  }
}
</style>
